import { CollectionView } from 'backbone.marionette';
import Radio from 'backbone.radio';
import { User } from '../../../models';
import { Preloader } from '../../../utils';
import { LeagueRowView, EmptyLeagueRowView } from '../../../views/components';

const globalChannel = Radio.channel( 'global' );

/**
 * @desc Table My View Class
 * This class using on leagues my page ('fantasy/leagues')
 */
export default class LeagueTableView extends CollectionView {
	get className() {
		return "my-leagues-table";
	}

	get childView() {
		return LeagueRowView;
	}

	get emptyView() {
		return EmptyLeagueRowView;
	}

	get childViewOptions() {
		return {
			user: User
		}
	}

	get default_limit() {
		return 100;
	}

	/**
	 *    Initialize view data
	 */
	async initialize() {
		this.regeneration          = this.getOption( 'regeneration' );
		this.historical_collection = [];
		this.user                  = User;
		this.limit                 = this.default_limit;
		this.offset                = 0;
		this.rounds                = this.getOption( 'rounds' );
		await this.updatePageData();
		this.updateData()
			.initListeners()
			.isShowMoreButton();

		Preloader.hide();
	}

	initListeners() {
		this.listenTo( globalChannel, 'click:load:more', this.showMore );

		return this;
	}

	/**
	 *
	 * @returns {*|Promise.<Object>}
	 */
	fetchData() {
		return Promise.all( [
			this.collection.show_my( {
				limit: this.limit
			} )
		] ).then();
	}

	showMore() {
		this.limit += this.default_limit;
		this.updatePageData();

		return this;
	}

	isShowMoreButton() {
		if( this.collection ) {
			let is_load_more = this.collection.length === (this.limit + this.offset);
			globalChannel.trigger( 'is:show:load:more', is_load_more );
		}

		return this;
	}

	updateData() {
		return this;
	}

	async updatePageData() {
		Preloader.show();
		await this.fetchData();
		Preloader.hide();
	}
}